<mat-tab-group *ngIf="!ongoingTraining">
  <mat-tab label="New Excercise">
     <app-new-training ></app-new-training>
  </mat-tab>
  <mat-tab label="Past Excercises">
    <app-past-training></app-past-training> 
  </mat-tab>
</mat-tab-group>
<app-current-training *ngIf="ongoingTraining"></app-current-training>